"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionLightModel = void 0;
const session_model_abstract_1 = require("./session.model.abstract");
class SessionLightModel extends session_model_abstract_1.SessionModelAbstract {
    constructor(obj = null, deepClone = false, model = 'SessionLightModel') {
        super(model);
        if (obj != null) {
            this.clone(obj, deepClone);
        }
    }
    clone(obj, deep = false) {
        this.idSession = obj.idSession;
        this.category = obj.category;
        this.categories = obj.categories;
        this.certification = obj.certification;
        this.internalProductCode = obj.internalProductCode;
        this.productCode = obj.productCode;
        this.endDate = obj.endDate ? new Date(Date.parse(obj.endDate.toString())) : null;
        this.startDate = obj.startDate ? new Date(Date.parse(obj.startDate.toString())) : null;
        this.duration = obj.duration;
        this.durationType = obj.durationType;
        this.lessionMode = obj.lessionMode;
        this.discountPercent = obj.discountPercent;
        this.previewUrl = obj.previewUrl;
        this.previewUrlAlt = obj.previewUrlAlt;
        this.price = obj.price;
        this.discountPrice = obj.discountPrice;
        this.priceNoVat = obj.priceNoVat;
        this.onSale = obj.onSale;
        this.location = obj.location;
        this.approved = obj.approved;
        this.courseTypeFull = obj.courseTypeFull;
        this.planType = obj.planType;
        this.title = obj.title;
        this.slug = obj.slug;
        this.onSale = obj.onSale;
        this.onSaleLabel = obj.onSaleLabel;
        this.stage = obj.stage;
        this.placement = obj.placement;
        this.lastSeats = obj.lastSeats;
        this.lessionMode = obj.lessionMode;
        this.admissionForm = obj.admissionForm;
        ;
        this.soldOut = obj.soldOut;
        this.buyButtonAvailable = obj.buyButtonAvailable;
        this.durationSlug = obj.durationSlug;
        this.lessionModeSlug = obj.lessionModeSlug;
        this.promoDetailLabel = obj.promoDetailLabel;
        this.promoLabelStyle = obj.promoLabelStyle;
        this.isMainSession = obj.isMainSession;
        this.tags = Object.assign({}, obj.tags);
        this.ranking = obj.ranking;
        this.credits_cfu = obj.credits_cfu;
        this.credits_cfp = obj.credits_cfp;
        this.hourDuration = obj.hourDuration;
        if (deep) {
            obj.alternativeSessions.forEach(v => this.alternativeSessions.push(v));
            obj.alternativeStartDates.forEach(v => this.alternativeStartDates.push(v));
        }
        else {
            this.alternativeSessions = obj.alternativeSessions;
            this.alternativeStartDates = obj.alternativeStartDates;
        }
        this.admissionWithBuyAvailable = obj.admissionWithBuyAvailable;
        this.vatFree = obj.vatFree;
        this.certificationReleaseEntity = obj.certificationReleaseEntity.length > 0 ? [...obj.certificationReleaseEntity] : [];
        this.alwaysOn = obj.lessonsAvailableImmediately;
        this.lessonsAvailableImmediately = obj.lessonsAvailableImmediately;
        this.hasBonus = obj.hasBonus;
        this.hasDiscount = obj.hasDiscount;
        this.urlCourse = obj.urlCourse;
    }
    static fromJSON(d) {
        const sessionInstance = Object.assign(new SessionLightModel(), typeof d === 'string' ? JSON.parse(d) : d);
        return new SessionLightModel(sessionInstance);
    }
}
exports.SessionLightModel = SessionLightModel;
//# sourceMappingURL=sessionlight.model.js.map